import "./footer.css";

const Footer = () => {
  return (
    <footer className="bottom-bar">
      <p>© 2025 ScanTAPS. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
